import React from "react";
import { Modal, Button } from "@tvg/design-system";
import { NullaryFn, UnaryFn } from "@tvg/ts-types/Functional";
import { QA_LABELS } from "../../utils/constants";
import { Container, ActionWrapper } from "./styled-components";

export interface Props {
  title?: string;
  subtitle?: string;
  description?: JSX.Element | null;
  isOpen: boolean;
  onClose: UnaryFn<string | void, void>;
  onBack?: NullaryFn<void>;
  onConfirm: UnaryFn<string, void>;
}

const confirmBtnTxt = "Yes";
const cancelBtnTxt = "No";

const ConfirmationModal = ({
  isOpen,
  title,
  subtitle,
  description,
  onClose,
  onBack,
  onConfirm
}: Props) => (
  <Modal
    isOpen={isOpen}
    title={title || ""}
    qaLabel={QA_LABELS.CONFIRM_MODAL}
    paddingX={48}
    paddingBottom={36}
    paddingTop={16}
    maxWidth="460px"
    subtitle={subtitle}
    onClose={onClose}
    onOverlayClick={onClose}
    hasBorderBottom={false}
    onBack={onBack}
  >
    <Container>
      {description}
      <ActionWrapper>
        <Button
          width="55px"
          variant="primary"
          onPress={() => onConfirm(confirmBtnTxt)}
          qaLabel="apptentive-survey-action-yes"
        >
          {confirmBtnTxt}
        </Button>
        <Button
          width="55px"
          variant="primary"
          onPress={() => onClose(cancelBtnTxt)}
          qaLabel="apptentive-survey-action-no"
        >
          {cancelBtnTxt}
        </Button>
      </ActionWrapper>
    </Container>
  </Modal>
);

export default ConfirmationModal;
